/**
 * Bill Approval / Validate Upload Endpoints
 */
export const BILL_APPROVAL_ENDPOINTS = {
  pendingBills: 'bill-approval/pending-bills',
  approve: 'bill-approval/approve',
  reject: 'bill-approval/reject',
  rejectionReasons: 'rejected-reason/list',
} as const;
